








import { defineComponent } from 'vue-demi';
import { language } from '@tencent/ppd-base-libs';
import { useRoute } from '@tencent/wphk-components-hooks';
import { COUPON_QRY_TYPE } from '@/api/displayCoupon/display-coupon';
import { biClick } from '@tencent/fit-bi-sdk';
export default defineComponent({
  name: 'DisplayCouponLink',
  props: {
    /** 过期券访问入口展示文案 */
    invalidCouponText: {
      type: String,
    },
  },
  setup() {
    const { router } = useRoute();
    /** c跳转去cdk兑券页 */
    function goCouponExchange() {
      biClick('home.coupon_exchange_click');
      router.push({
        name: 'couponExchange',
      });
    }
    /** 展示不可用展示券列表 */
    function showInvalidList() {
      biClick('home.usedlist_click');
      router.push({
        name: 'displaycouponlist',
        query: { type: COUPON_QRY_TYPE.INVALID },
      });
    }

    return {
      isEn: language.isEn(),
      goCouponExchange,
      showInvalidList,
    };
  },
});
